import { Skeleton } from '../Skeleton';

export function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      {/* Stat cards row */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="rounded-lg border border-brand-neutral-200 bg-surface p-4">
            <div className="flex items-center gap-3">
              <Skeleton circle={40} />
              <div className="flex-1 space-y-2">
                <Skeleton width="w-20" height="h-3" />
                <Skeleton width="w-12" height="h-6" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Deadlines widget */}
      <div className="rounded-lg border border-brand-neutral-200 bg-surface p-4">
        <Skeleton width="w-40" height="h-5" className="mb-4" />
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton circle={8} />
              <Skeleton width="w-full" height="h-4" className="flex-1" />
              <Skeleton width="w-20" height="h-4" />
            </div>
          ))}
        </div>
      </div>

      {/* Two-column grid: services + invoices */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Services card */}
        <div className="rounded-lg border border-brand-neutral-200 bg-surface p-4">
          <Skeleton width="w-32" height="h-5" className="mb-4" />
          <div className="space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-center justify-between rounded-md border border-brand-neutral-100 p-3">
                <div className="space-y-2">
                  <Skeleton width="w-40" height="h-4" />
                  <Skeleton width="w-24" height="h-3" />
                </div>
                <Skeleton width="w-16" height="h-6" rounded="full" />
              </div>
            ))}
          </div>
        </div>

        {/* Invoices card */}
        <div className="rounded-lg border border-brand-neutral-200 bg-surface p-4">
          <Skeleton width="w-32" height="h-5" className="mb-4" />
          <div className="space-y-2">
            {/* Table header */}
            <div className="flex gap-4 pb-2">
              <Skeleton width="w-20" height="h-3" />
              <Skeleton width="w-16" height="h-3" />
              <Skeleton width="w-16" height="h-3" className="ml-auto" />
              <Skeleton width="w-14" height="h-3" />
            </div>
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-center gap-4 py-2">
                <Skeleton width="w-20" height="h-4" />
                <Skeleton width="w-16" height="h-4" />
                <Skeleton width="w-16" height="h-4" className="ml-auto" />
                <Skeleton width="w-14" height="h-5" rounded="full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
